import * as React from 'react';
import { useField } from "formik";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import arLocale from "date-fns/locale/ar-SA";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr"

import { t } from "../services";
import { FormControl, InputLabel } from '@mui/material';


export function DateInput(props) {

  const [field, meta, helpers] = useField(props.name);
  const [language, setLanguage] = React.useState(undefined);
  const [locale, setLocal] = React.useState(undefined);
  const { value } = meta;
  const { setValue } = helpers;

  const adjustTimezoneOffset = newDate => {
    var date = new Date(newDate);
    var timezoneOffset = date.getTimezoneOffset() * 60 * 1000;
    return new Date(date.getTime() - timezoneOffset);
  }

  const handleDateChange = newDate => {
    setValue(newDate);
  };

  if (!locale || language != props.language) {
    setLanguage(props.language);
    if (props.language == "ar")
      setLocal(arLocale);
    else if (props.language == "en")
      setLocal(enLocale)
    else if (props.language == "fr")
      setLocal(frLocale);
    else
      setLocal(enLocale)
  }
  return (
    <FormControl variant="standard">
      <InputLabel shrink htmlFor={props.name}>
        {props.label}
      </InputLabel>
      <LocalizationProvider dateAdapter={AdapterDayjs} >
        <DatePicker
          margin="normal"
          placeholder="dd/mm/yyyy"
          id={props.id}
          format="DD-MM-YYYY"
          value={value}
          minDate={undefined}
          onChange={handleDateChange}
          KeyboardButtonProps={{
            'aria-label': t`change date`,
          }}
          disabled={props.disabled}
          /*  ToolbarComponent={
             (toolbarProps) => (
                 <div>
                     <CustomDateToolbar {...toolbarProps}/>
                 </div>
             )
         } */
          okLabel={t`ok`}
          cancelLabel={t`cancel`}
          InputLabelProps={{ shrink: false }}
        />
      </LocalizationProvider>
    </FormControl>
  );
}